import faceScanIcon from './face-scan.svg'
import crossIcon from './cross.svg'

const icons = {
	faceScan: faceScanIcon,
	cross: crossIcon,
}

export default icons